const SuppliersPart = ({ suppliers }) => (
  <div className="px-10 md:px-20 py-20 bg-blue-850 relative -top-36 md:-top-48">
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-20 w-11/12 mx-auto mt-20 xl:mt-10">
      {suppliers?.map((supplier) => (
        <img
          src={supplier.image}
          alt={supplier.description}
          key={supplier._id}
          className="w-24 h-16 md:w-32 lg:h-20 mx-auto fill-white hover:fill-green-500 hover:scale-125 cursor-pointer transform transition-all duration-200 ease-linear"
        />
      ))}
    </div>
  </div>
);

export default SuppliersPart;
